export default __webpack_public_path__ + "static/media/wallet.cf9b0ed2.png";